export default "__VITE_ASSET__DJaDgrZA__"